import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'apps/new-web/views/component';
import Image from 'apps/new-web/views/components/image';
import I18n from 'apps/new-web/views/components/i18n';
import GoogleLoginWrapper from 'apps/new-web/views/components/google-login-wrapper';
class GoogleLogin extends BaseComponent {
  static get propTypes() {
    return {
      clientId: PropTypes.string.isRequired,
      loginWithGoogle: PropTypes.func.isRequired
    };
  }

  render() {
    return (
      <GoogleLoginWrapper onAccessToken={ this.props.loginWithGoogle } clientId={ this.props.clientId }>
        <button className="google-login social-login">
          <Image src="/img/google.svg" width="24px" />
          <p><I18n args={{ google: 'Google' }}>Sign in with [google]</I18n></p>
        </button>
      </GoogleLoginWrapper>
    );
  }
}

export default GoogleLogin;
